__turbopack_context__.v({
  "root": "styles-module-scss-module__1NkX6q__root",
});
